import React from "react";

const ChatBubbleLeft = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-chat-bubble"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-chat-bubble"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M12.014,23.666c-.595,0-1.196-.21-1.675-.636l-3.598-3.03h-1.241c-3.033,0-5.5-2.467-5.5-5.5V5.5C0,2.467,2.467,0,5.5,0h13c3.032,0,5.5,2.467,5.5,5.5V14.5c0,3.033-2.468,5.5-5.5,5.5h-1.171l-3.708,3.065c-.448,.399-1.024,.601-1.606,.601Zm-.318-2.901l-.028,.023,.028-.023Zm.59-.017l.016,.014-.016-.014ZM5.5,3c-1.378,0-2.5,1.122-2.5,2.5V14.5c0,1.378,1.122,2.5,2.5,2.5h1.789c.354,0,.696,.125,.966,.353l3.749,3.158,3.829-3.167c.27-.222,.607-.344,.956-.344h1.711c1.379,0,2.5-1.122,2.5-2.5V5.5c0-1.378-1.121-2.5-2.5-2.5H5.5Z" />
    </svg>
  );
};

export default ChatBubbleLeft;
